import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  definirMeuFeriadoAtivo,
  fetchLugaresDoAcervo,
  fetchMeusFeriados,
  lancarFeriado,
  type LancarFeriadoInput,
} from '../api/meusFeriados';
import { queryKeys } from '../lib/pwa/queryConfig';

const CHAVE = ['prazos', 'meus-feriados'] as const;

export function useMeusFeriados() {
  return useQuery({ queryKey: CHAVE, queryFn: fetchMeusFeriados });
}

/** Os lugares do acervo para o lançamento avulso; só quando o diálogo abre. */
export function useLugaresDoAcervo(enabled: boolean) {
  return useQuery({ queryKey: [...CHAVE, 'lugares'], queryFn: fetchLugaresDoAcervo, enabled });
}

/**
 * O lançamento refaz os vencimentos da conta e move os eventos da agenda: as
 * comunicações, a agenda, a régua do painel e a própria lista ficam velhas.
 */
function useInvalidarContas() {
  const queryClient = useQueryClient();
  return () =>
    Promise.all([
      queryClient.invalidateQueries({ queryKey: CHAVE }),
      queryClient.invalidateQueries({ queryKey: queryKeys.comunicacoes.all }),
      queryClient.invalidateQueries({ queryKey: ['calendario'] }),
      queryClient.invalidateQueries({ queryKey: queryKeys.dashboard.regua }),
    ]);
}

export function useLancarFeriado() {
  const invalidar = useInvalidarContas();
  // Sem rede, a mutation pausaria com o botão girando e o diálogo preso: o
  // lançamento precisa do servidor para refazer as contas — falha na hora.
  return useMutation({
    networkMode: 'always',
    mutationFn: (input: LancarFeriadoInput) => lancarFeriado(input),
    onSuccess: invalidar,
  });
}

export function useDefinirMeuFeriadoAtivo() {
  const invalidar = useInvalidarContas();
  return useMutation({
    networkMode: 'always',
    mutationFn: ({ id, ativo }: { id: string; ativo: boolean }) => definirMeuFeriadoAtivo(id, ativo),
    onSuccess: invalidar,
  });
}
